import { render } from "./TablaReporteRegistros.vue?vue&type=template&id=14ae16b8&scoped=true"
import script from "./TablaReporteRegistros.vue?vue&type=script&lang=js"
export * from "./TablaReporteRegistros.vue?vue&type=script&lang=js"

import "./TablaReporteRegistros.vue?vue&type=style&index=0&id=14ae16b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14ae16b8"]])

export default __exports__